import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 24px;
	background: ${(p) => p.theme.gray[0]};
	border-radius: 12px;
	padding: 20px 24px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);

	@media (max-width: 768px) {
		flex-direction: column;
		align-items: stretch;
	}
`;

export const Info = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const PlanName = styled.div`
	font-size: 18px;
	font-weight: 600;
	color: ${(p) => p.theme.blue[400]};
`;

export const Renewal = styled.div`
	font-size: 14px;
	color: ${(p) => p.theme.gray[600]};
`;

export const Actions = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;

	@media (max-width: 768px) {
		justify-content: space-between;
	}
`;

export const CancelLink = styled.button`
	background: none;
	border: none;
	padding: 0;
	font-family: inherit;
	font-size: 13px;
	font-weight: 500;
	color: ${(p) => p.theme.gray[600]};
	transition: color 0.2s ease-in-out;

	&:hover {
		color: ${(p) => p.theme.gray[400]};
	}
`;
